import BaseService from "./BaseService";

export default class DashboardService extends BaseService {
    private static getEndpoint(basePath: string, countryId: string): string {
        return countryId
            ? `${process.env.REACT_APP_API_URL}${basePath}/v2/${countryId}`
            : `${process.env.REACT_APP_API_URL}${basePath}/v2`;
    }

    public static getDashbaordDetails(token: string, postData: any, countryId: string) {
        return BaseService.sendRequest(
            this.getEndpoint('dashboard', countryId),
            {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + token
                },
                body: JSON.stringify(postData)
            }
        );
    }

    public static getDashboardUserMetric(token: string, postData: any, countryId: string) {
        return BaseService.sendRequest(
            this.getEndpoint('dashboard/user-metric', countryId),
            {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + token
                },
                body: JSON.stringify(postData)
            },
            undefined,
            true
        );
    }

    public static getDashbaordFinancialMetric(token: string, postData: any, countryId: string) {
        return BaseService.sendRequest(
            this.getEndpoint('dashboard/financial-metric', countryId),
            {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + token
                },
                body: JSON.stringify(postData)
            },
            undefined,
            true
        );
    }

    public static getDashboardComplianceRiskMetrics(token: string, postData: any, countryId: string) {
        return BaseService.sendRequest(
            this.getEndpoint('dashboard/compliance-risk-metrics', countryId),
            {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + token
                },
                body: JSON.stringify(postData)
            },
            undefined,
            true
        );
    }

    public static getDashboardBehaviorAndEngagement(token: string, postData: any, countryId: string) {
        return BaseService.sendRequest(
            this.getEndpoint('dashboard/behavior-and-engagement', countryId),
            {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + token
                },
                body: JSON.stringify(postData)
            },
            undefined,
            true
        );
    }

    public static getDashboardPerformanceSystemMetrics(token: string, postData: any, countryId: string) {
        return BaseService.sendRequest(
            this.getEndpoint('dashboard/performance-system-metrics', countryId),
            {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + token
                },
                body: JSON.stringify(postData)
            },
            undefined,
            true
        );
    }
    
    public static getDashboardCustomerSupportMetrics(token: string, postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'dashboard/customer-support-metrics', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }
}